import { Route, Routes, BrowserRouter as Router, useLocation } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import 'datatables.net-responsive-bs5/css/responsive.bootstrap5.min.css';
import 'datatables.net-buttons-bs5/css/buttons.bootstrap5.min.css';
import "lineicons/dist/lineicons.css";
import 'boxicons/css/boxicons.min.css';
import 'simplebar-react/dist/simplebar.min.css';
import "datatables.net-bs5";
import "datatables.net-responsive-bs5";
import "datatables.net-buttons";
import "datatables.net-buttons-bs5";
import "datatables.net-buttons/js/buttons.html5.js";
import "datatables.net-buttons/js/buttons.print.js";
import "quill/dist/quill.snow.css";
import './App.css';
import Home from './pages/Home';
import AuthCoverSignin from './pages/auth/AuthCoverSignin';
import AuthLayout from './AuthLayout';
import MainLayout from './MainLayout';
import AuthCoverForgotPassword from './pages/auth/AuthCoverForgotPassword';
import AuthCoverSignup from './pages/auth/AuthCoverSignup';
import AuthCoverResetPassword from './pages/auth/AuthCoverResetPassword';
import "nprogress/nprogress.css";
import { useEffect } from 'react';
import nProgress from 'nprogress';
import ClubManagement from './pages/ClubManagement';
import ClubManagementDetail from './pages/ClubManagementDetail';
import RefereeManagement from './pages/RefereeManagement';
import RefereeDetail from './pages/RefereeDetail';
import CoachManagement from './pages/CoachManagement';
import CoachDetail from './pages/CoachDetail';
import GameManagement from './pages/GameManagement';
import GameManagementDetail from './pages/GameManagementDetail';
import CreateGame from './pages/CreateGame';
import TeamManagement from './pages/TeamManagement';
import CreateTeam from './pages/CreateTeam';
import TeamManagementDetail from './pages/TeamManagementDetail';
import AddPlayer from './pages/AddPlayer';
import TeamPlayerDetail from './pages/TeamPlayerDetail';
import Finances from './pages/Finances';
import RolesManagement from './pages/RolesManagement';
import Setting from './pages/Setting';


function App() {
  const location = useLocation();

  useEffect(() => {
    nProgress.start();

    const timer = setTimeout(() => {
      nProgress.done();
    }, 300);

    return () => clearTimeout(timer);
  }, [location.pathname]);

  return (
    <>
      <Routes>
        <Route element={<AuthLayout />}>
          <Route path='/auth-cover-signin' element={<AuthCoverSignin />} />
          <Route path='/auth-cover-forgot-password' element={<AuthCoverForgotPassword />} />
          <Route path='/auth-cover-signup' element={<AuthCoverSignup />} />
          <Route path='/auth-cover-reset-password' element={<AuthCoverResetPassword />} />
        </Route>
        <Route element={<MainLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/club-management" element={<ClubManagement />} />
          <Route path="/club-management-detail" element={<ClubManagementDetail />} />
          <Route path="/referee-management" element={<RefereeManagement />} />
          <Route path="/referee-detail" element={<RefereeDetail />} />
          <Route path="/coach-management" element={<CoachManagement />} />
          <Route path="/coach-detail" element={<CoachDetail />} />
          <Route path="/game-management" element={<GameManagement />} />
          <Route path="/game-management-detail" element={<GameManagementDetail />} />
          <Route path="/create-game" element={<CreateGame />} />
          <Route path="/team-management" element={<TeamManagement />} />
          <Route path="/create-team" element={<CreateTeam />} />
          <Route path="/team-management-detail" element={<TeamManagementDetail />} />
          <Route path="/add-player" element={<AddPlayer />} />
          <Route path="/team-player-detail" element={<TeamPlayerDetail />} />
          <Route path="/finances" element={<Finances />} />
          <Route path="/roles-management" element={<RolesManagement />} />
          <Route path="/setting" element={<Setting />} />
        </Route>
      </Routes>
    </>
  );
}

const WrappedApp = () => (
  <Router>
    <App />
  </Router>
);

export default WrappedApp;
